
export enum FilePickerStatus {
  CANCELLED = 'cancelled',
  UNSUPPORTED = 'unsupported'
}
